import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/UpgradeSubscriptionPlan', 'post'>;

type Params = {
  lookupKey: string;
};

export const upgradeSubscriptionFactory = (apiClient: ApiClient) => {
  const upgradeSubscription = async (variables: Params): Promise<void> => {
    const requestParams = mapInputToRequestParams(variables);
    await apiClient['/api/UpgradeSubscriptionPlan'].post(requestParams);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      json: {
        lookupKey: input.lookupKey,
      },
    };
  };

  return upgradeSubscription;
};
